/**
 * Created by Ning Jiang on 5/23/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Circ, Elastic, Linear, Power4, SlowMo, TimelineLite, TimelineMax, TweenLite, TweenMax} from "gsap";
import {Fruits} from "../../Fruits";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {BonusGameIntroView} from "../../screen/bonusgame/intro/BonusGameIntroView";


export class FruitsReelAreaView extends ReelAreaView {

    public static readonly GAME_MODE_SWITCHING_COMPLETED:string = "fruitsReelAreaView_gameModeSwitchingComplete";
    private _orientation:Orientation;
    private _masks:PIXI.Sprite[];

    private _X2Container:PIXI.Container;
    private _X4Container:PIXI.Container;
    private _X2Bg:PIXI.Sprite;
    private _X4Bg:PIXI.Sprite;
    private _X2ReelsContainer:PIXI.Container;
    private _X4ReelsContainer:PIXI.Container;

    // temp
    private _X2Splash:PIXI.Sprite;
    private _X4Splash:PIXI.Sprite;

    private _gameMode:string = GameMode.NORMAL;
    private _tweenIntroPositions:{ tween1_X2:{ x:string; y:string }; tween1_X4:{ x:string; y:string }; tween2_X2:{ x:string; y:string }; tween2_X4:{ x:string; y:string } };
    private _tweenOutroPositions:{ tween1_X2:{ x:string; y:string }; tween1_X4:{ x:string; y:string }; tween2_X2:{ x:string; y:string }; tween2_X4:{ x:string; y:string } };

    private _resourcesLoaded:boolean = false;

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);

        this._masks = [];

        this._X2Bg = new PIXI.Sprite();
        this._X2Bg.anchor.set(0.5, 0.5);

        this._X2ReelsContainer = new PIXI.Container();

        this._X2Container = new PIXI.Container();
        this._X2Container.addChild(this._X2Bg);
        this._X2Container.addChild(this._X2ReelsContainer);

        this._X4Bg = new PIXI.Sprite();
        this._X4Bg.anchor.set(0.5, 0.5);

        this._X4ReelsContainer = new PIXI.Container();

        this._X4Container = new PIXI.Container();
        this._X4Container.addChild(this._X4Bg);
        this._X4Container.addChild(this._X4ReelsContainer);

        this._tweenIntroPositions = {
            tween1_X2 : {
                x : "+=14",
                y : ""
            },
            tween1_X4 : {
                x : "-=12",
                y : ""
            },
            tween2_X2 : {
                x : "-=79",
                y : ""
            },
            tween2_X4 : {
                x : "+=72",
                y : ""
            }

        };

        this._tweenOutroPositions = {
            tween1_X2 : {
                x : "-=14",
                y : ""
            },
            tween1_X4 : {
                x : "+=12",
                y : ""
            },
            tween2_X2 : {
                x : "+=79",
                y : ""
            },
            tween2_X4 : {
                x : "-=72",
                y : ""
            }

        };

        this.addChild(this._X4Container);
        this.addChild(this._X2Container);
    }

    protected initAnimations():void {
        this._X2Bg.texture = GameResources.getTextures("ReelBgX2")[0];
        this._X4Bg.texture = GameResources.getTextures("ReelBgX4")[0];

        const X2Temp:PIXI.Graphics = new PIXI.Graphics();
        X2Temp.beginFill(0xffffff, 1);
        X2Temp.drawRect(-FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.5, -FruitsGameConfig.instance.REELS_X2_SIZE[1] * 0.5, FruitsGameConfig.instance.REELS_X2_SIZE[0], FruitsGameConfig.instance.REELS_X2_SIZE[1]);
        X2Temp.endFill();

        this._X2Splash = new PIXI.Sprite();
        this._X2Splash.anchor.set(0.5, 0.5);
        this._X2Splash.visible = false;
        this._X2Splash.addChild(X2Temp);
        this._X2Container.addChild(this._X2Splash);

        const X4Temp:PIXI.Graphics = new PIXI.Graphics();
        X4Temp.beginFill(0xffffff, 1);
        X4Temp.drawRect(-FruitsGameConfig.instance.REELS_X4_SIZE[0] * 0.5, -FruitsGameConfig.instance.REELS_X4_SIZE[1] * 0.5, FruitsGameConfig.instance.REELS_X4_SIZE[0], FruitsGameConfig.instance.REELS_X4_SIZE[1]);
        X4Temp.endFill();

        this._X4Splash = new PIXI.Sprite();
        this._X4Splash.anchor.set(0.5, 0.5);
        this._X4Splash.visible = false;
        this._X4Splash.addChild(X4Temp);
        this._X4Container.addChild(this._X4Splash);

        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            if(!reelView.mask) {
                this.addMaskToReelView(reelId);
            }
        });

        this._resourcesLoaded = true;
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        const positionMode:string = this._gameMode === FruitsGameMode.BONUS_GAME ? this._gameMode : FruitsGameMode.NORMAL;
        const x2Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X2_POSITION_${positionMode}_${resizeData.orientation.toUpperCase()}`];
        const x4Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X4_POSITION_${positionMode}_${resizeData.orientation.toUpperCase()}`];

        this._orientation = resizeData.orientation;

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._tweenIntroPositions.tween1_X2.x = "";
            this._tweenIntroPositions.tween1_X2.y = "+=14";
            this._tweenIntroPositions.tween1_X4.x = "";
            this._tweenIntroPositions.tween1_X4.y = "-=12";
            this._tweenIntroPositions.tween2_X2.x = "";
            this._tweenIntroPositions.tween2_X2.y = "-=79";
            this._tweenIntroPositions.tween2_X4.x = "";
            this._tweenIntroPositions.tween2_X4.y = "+=72";

            this._tweenOutroPositions.tween1_X2.x = "";
            this._tweenOutroPositions.tween1_X2.y = "-=14";
            this._tweenOutroPositions.tween1_X4.x = "";
            this._tweenOutroPositions.tween1_X4.y = "+=12";
            this._tweenOutroPositions.tween2_X2.x = "";
            this._tweenOutroPositions.tween2_X2.y = "+=79";
            this._tweenOutroPositions.tween2_X4.x = "";
            this._tweenOutroPositions.tween2_X4.y = "-=72";
        }

        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._tweenIntroPositions.tween1_X2.x = "+=14";
            this._tweenIntroPositions.tween1_X2.y = "";
            this._tweenIntroPositions.tween1_X4.x = "-=12";
            this._tweenIntroPositions.tween1_X4.y = "";
            this._tweenIntroPositions.tween2_X2.x = "-=79";
            this._tweenIntroPositions.tween2_X2.y = "";
            this._tweenIntroPositions.tween2_X4.x = "+=72";
            this._tweenIntroPositions.tween2_X4.y = "";

            this._tweenOutroPositions.tween1_X2.x = "-=14";
            this._tweenOutroPositions.tween1_X2.y = "";
            this._tweenOutroPositions.tween1_X4.x = "+=12";
            this._tweenOutroPositions.tween1_X4.y = "";
            this._tweenOutroPositions.tween2_X2.x = "+=79";
            this._tweenOutroPositions.tween2_X2.y = "";
            this._tweenOutroPositions.tween2_X4.x = "-=72";
            this._tweenOutroPositions.tween2_X4.y = "";

        }

        this._X2Container.position.set(x2Position[0], x2Position[1]);
        this._X4Container.position.set(x4Position[0], x4Position[1]);

        const rotation:number = resizeData.orientation === Orientation.PORTRAIT ? Math.PI * 0.5 : 0;
        this._X2Bg.rotation = rotation;
        this._X4Bg.rotation = rotation;
        this._X2Splash.rotation = rotation;
        this._X4Splash.rotation = rotation;
    }

    public addReelView(reel:ReelController):void {
        this._reelViews[reel.reelId] = reel.view;
        this.updateReelViewPosition(reel.view, reel.reelId);
        if(reel.reelId < 4) {
            this._X2ReelsContainer.addChild(reel.view);
        } else {
            this._X4ReelsContainer.addChild(reel.view);
        }

        const mask:PIXI.Sprite = new PIXI.Sprite();
        mask.anchor.set(0.5, 0.5);
        mask.position.set(0, 84);
        reel.view.addChild(mask);
        this._masks[reel.reelId] = mask;
        if(this._resourcesLoaded) {
            this.addMaskToReelView(reel.reelId);
        }
    }

    private addMaskToReelView(reelId:number):void {
        const mask:PIXI.Sprite = this._masks[reelId];
        mask.texture = GameResources.getTextures("reelViewMask")[0];
        const reel = Reels.getReel(reelId);
        reel!.view.mask = mask;
    }

    public changeGameMode(newMode:string):void {
        this._gameMode = newMode;
    }

    public get orientation():Orientation {
        return this._orientation;
    }

    public getViewPresentation(newMode:string, shouldAnimate:boolean, showIntro?:boolean, isRestoreAndTriggered?:boolean):TimelineLite {
        if(isRestoreAndTriggered) {
            return this.getRestoreIntro();
        }

        if(showIntro) {
            return this.getIntroAnimation();
        } else if(newMode === FruitsGameMode.NORMAL && shouldAnimate) {
            return this.getOutroAnimation();
        }

        const timeline:TimelineLite = new TimelineLite();

        const x2Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X2_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];
        const x4Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X4_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];

        timeline.add([
            TweenLite.to(this._X2Container, 0.5, {x : x2Position[0], y : x2Position[1]}),
            TweenLite.to(this._X4Container, 0.5, {x : x4Position[0], y : x4Position[1]})
        ]);

        if(shouldAnimate) {
            timeline.add(() => {
                TweenLite.fromTo(this._X2Splash, 1,
                    {alpha : 1},
                    {
                        alpha : 0,
                        ease : Circ.easeIn,
                        onStart : () => this._X2Splash.visible = true,
                        onComplete : () => this._X2Splash.visible = false
                    }
                );
                TweenLite.fromTo(this._X4Splash, 1,
                    {alpha : 1},
                    {
                        alpha : 0,
                        ease : Circ.easeIn,
                        onStart : () => this._X4Splash.visible = true,
                        onComplete : () => this._X4Splash.visible = false
                    }
                );
            });
        }

        return timeline;


    }

    private x2AnimationPart():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            TweenLite.to(this._X2Container.scale, 0.04, {x : 0.95, y : 0.95, ease : Power4.easeOut}),
        ]);
        tl.add([
            TweenLite.to(this._X2Container.scale, 0.08, {x : 1.05, y : 1.05, ease : Power4.easeOut}),
        ]);
        tl.add([
            TweenLite.to(this._X2Container.scale, 0.08, {x : 1, y : 1, ease : Circ.easeOut}),
        ]);

        return tl;
    }

    private x4AnimationPart():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => this._X4Container.scale.set(0.96, 0.96));
        tl.add(TweenLite.to(this._X4Container.scale, 0.2, {x : 1, y : 1, ease : Power4.easeOut}));

        return tl;
    }

    private darkenX4():TweenLite {
        return TweenLite.to(this._X4Container, 0.3, {pixi:{brightness:0.5}, ease : SlowMo.ease.config(0.5, 0.1, true)});
    }

    private resetX4filter():void {
        TweenLite.to(this._X4Container, 0.01, {pixi:{brightness:1}});
    }

    private getRestoreIntro():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(FruitsGameModuleConfig.preIntroScreenViewBit.getAnimation());
        tl.add(() => EventHandler.dispatchEvent(new GameEvent(BonusGameIntroView.START_BONUS_INTRO_PRES)));

        return tl;

    }

    public getIntroAnimation(orientationChange:boolean = false):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        if(orientationChange) {
            const x2PositionNormal:[number, number] = (<any>FruitsGameConfig.instance)[`_X2_POSITION_NORMAL_${StageManager.orientation.toUpperCase()}`];
            const x4PositionNormal:[number, number] = (<any>FruitsGameConfig.instance)[`_X4_POSITION_NORMAL_${StageManager.orientation.toUpperCase()}`];

            this._X2Container.position.set(x2PositionNormal[0], x2PositionNormal[1]);
            this._X4Container.position.set(x4PositionNormal[0], x4PositionNormal[1]);
        }

        const x2Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X2_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];
        const x4Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X4_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];

        tl.add([
            () => FruitsGameModuleConfig.logoAnimationBit.changeLogo(FruitsGameMode.BONUS_GAME),
            TweenLite.to(this._X2Container, 0.35, {
                x : this._tweenIntroPositions.tween1_X2.x,
                y : this._tweenIntroPositions.tween1_X2.y,
                ease : Linear.easeNone
            }),
            TweenLite.to(this._X4Container, 0.35, {
                x : this._tweenIntroPositions.tween1_X4.x,
                y : this._tweenIntroPositions.tween1_X4.y,
                ease : Linear.easeNone
            }),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INTRO_HIT_1)
        ]);

        tl.add([
            TweenLite.to(this._X2Container, 0.45, {
                x : this._tweenIntroPositions.tween2_X2.x,
                y : this._tweenIntroPositions.tween2_X2.y,
                ease : Elastic.easeOut.config(1.2, 0.5)
            }),
            TweenLite.to(this._X4Container, 0.45, {
                x : this._tweenIntroPositions.tween2_X4.x,
                y : this._tweenIntroPositions.tween2_X4.y,
                ease : Elastic.easeOut.config(1.2, 0.5)
            })
        ]);
        tl.add([
            this.darkenX4(),
            TweenLite.to(this._X2Container, 0.3, {
                x : x2Position[0],
                y : x2Position[1],
                ease : SlowMo.ease.config(0.3, 0.7, false)
            }),
            TweenLite.to(this._X4Container, 0.3, {
                x : x4Position[0],
                y : x4Position[1],
                ease : SlowMo.ease.config(0.3, 0.7, false)
            }),
            TweenLite.to(this._X2Container.scale, 0.3, {
                x : 1.5,
                y : 1.5,
                ease : SlowMo.ease.config(0.5, 0.1, true)
            }),
            TweenLite.to(this._X4Container.scale, 0.3, {x : 0.8, y : 0.8, ease : SlowMo.ease.config(0.5, 0.1, true)}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INTRO_HIT_2)

        ]);
        tl.add([
            this.x2AnimationPart(),
            this.x4AnimationPart(),
            () => Fruits.basicBackground.backgroundShake(),
            () => this.resetX4filter()
        ]);

        tl.add(FruitsGameModuleConfig.preIntroScreenViewBit.getAnimation());

        return tl;
    }

    private getOutroAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(FruitsGameModuleConfig.preOutroScreenViewBit.getAnimation());
        tl.add(this.getReelTransition());

        return tl;
    }

    private getReelTransition(isAborted:boolean = false):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        if(isAborted) {
            tl.timeScale(2);
        }

        const x2Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X2_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];
        const x4Position:[number, number] = (<any>FruitsGameConfig.instance)[`_X4_POSITION_${this._gameMode}_${StageManager.orientation.toUpperCase()}`];

        tl.add([
            () => FruitsGameModuleConfig.logoAnimationBit.changeLogo(FruitsGameMode.NORMAL),
            TweenLite.to(this._X2Container, 0.35, {
                x : this._tweenOutroPositions.tween1_X2.x,
                y : this._tweenOutroPositions.tween1_X2.y,
                ease : Linear.easeNone
            }),
            TweenLite.to(this._X4Container, 0.35, {
                x : this._tweenOutroPositions.tween1_X4.x,
                y : this._tweenOutroPositions.tween1_X4.y,
                ease : Linear.easeNone
            })
        ]);
        tl.add([
            TweenLite.to(this._X2Container, 0.45, {
                x : this._tweenOutroPositions.tween2_X2.x,
                y : this._tweenOutroPositions.tween2_X2.y,
                ease : Elastic.easeOut.config(1.2, 0.5)
            }),
            TweenLite.to(this._X4Container, 0.45, {
                x : this._tweenOutroPositions.tween2_X4.x,
                y : this._tweenOutroPositions.tween2_X4.y,
                ease : Elastic.easeOut.config(1.2, 0.5)
            })
        ]);
        tl.add([
            this.darkenX4(),
            TweenLite.to(this._X2Container, 0.3, {
                x : x2Position[0],
                y : x2Position[1],
                ease : SlowMo.ease.config(0.3, 0.7, false)
            }),
            TweenLite.to(this._X4Container, 0.3, {
                x : x4Position[0],
                y : x4Position[1],
                ease : SlowMo.ease.config(0.3, 0.7, false)
            }),
            TweenLite.to(this._X2Container.scale, 0.3, {x : 1.5, y : 1.5, ease : SlowMo.ease.config(0.5, 0.1, true)}),
            TweenLite.to(this._X4Container.scale, 0.3, {x : 0.8, y : 0.8, ease : SlowMo.ease.config(0.5, 0.1, true)}),

        ]);
        tl.add([
            this.x2AnimationPart(),
            this.x4AnimationPart(),
            () => this.resetX4filter(),
            () => Fruits.basicBackground.backgroundShake(),
            () => FruitsGameModuleConfig.bonusOverlayView.initIndicator(),
            () => FruitsGameModuleConfig.bonusOverlayView.resetScatterOverlay(),
            () => FruitsGameModuleConfig.bonusOverlayView.resetIndicator(),
        ]);


        return tl;
    }


    public abortedOutroAnimation():TimelineLite {
        return this.getReelTransition(true);
    }
}